<template>
  <div>
    <div class="spinner-wrap" v-show="loading">
      <div class="spinner"></div>
    </div>
    <div class="step_apply step1">

      <!-- 단계 표시 그래프 -->
      <StepGraph/>

      <!-- 1단계 -->
      <div id="skipTargetContents" class="payment_step1 clearfix">
        <h3 class="header-title">상품 신청을 위해 꼭 필요한 정보입니다</h3>
        <div class="information-area">

          <GoodsTable
              :select-goods-id="selectGoodsId"
              @change-select-goods="changeSelectGoods"
          />

          <DomainCheck
              :package-id="packageId"
          />

          <SubGoodsTable
              :select-goods-id="selectGoodsId"
          />


          <!-- 약관 -->
          <Agreement/>

        </div>

        <PriceCalculate
            @show-estimate="showEstimate"
        />

      </div>


    </div>

    <transition name="fade">

      <Estimate
          v-show="isEstimateVisible"
          @hide-estimate="hideEstimate"
      />
    </transition>
    
  </div>
</template>

<script>
import Estimate from "@/components/step1/Estimate/Estimate";
import StepGraph from "./StepGraph";
import GoodsTable from "./GoodsTable/GoodsTable";
import DomainCheck from "./DomainCheck";
import SubGoodsTable from "@/components/step1/GoodsTable/SubGoodsTable";
import Agreement from "@/components/step1/Agreement";
import PriceCalculate from "@/components/step1/Calculate/PriceCalculate";
import {mapState} from 'vuex'

export default {
  name: 'App',
  components: {
    PriceCalculate,
    Agreement,
    SubGoodsTable,
    Estimate,
    StepGraph,
    GoodsTable,
    DomainCheck,
  },
  data(){
    return{
      packageId : null,
      selectGoodsId : null,
      isEstimateVisible : false,
    }
  },
  computed: {
    ...mapState({
      loading: state => state['loading'],
    })
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(to, from) {
        if(!from){
          this.init()
          return;
        }
        if(to.id === from.id){
          this.changeSelectGoodsInit(
              parseInt(to.select_goods)
          )
        }
      }
    }
  },
  methods:{
    init(){
      let urlSearchParams = new URLSearchParams(window.location.search)
      this.packageId = urlSearchParams.get('id') ? parseInt(urlSearchParams.get('id')) : null
      this.selectGoodsId = urlSearchParams.get('select_goods') ? parseInt(urlSearchParams.get('select_goods')) : null
      this.$store.dispatch('init', {
        packageId : this.packageId,
        selectGoodsId: this.selectGoodsId
      })
    },
    changeSelectGoodsInit(selectGoodsId){
      this.selectGoodsId = selectGoodsId
      this.$store.dispatch('changeSelectGoodsInit', selectGoodsId)
    },
    hideEstimate(){
      this.isEstimateVisible = false
    },
    changeSelectGoods(selectGoodsId){
      let routingInfo = {
        query : {
          id: this.packageId,
          select_goods: selectGoodsId
        }
      }
      this.$router.push(routingInfo)
    },
    showEstimate(){
      this.isEstimateVisible = true
    },
  },
}
</script>

<style lang="scss">
  @import "../../assets/scss/payment";

  .spinner-wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: #000;
    opacity: .3;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
  }

  @keyframes spinner {
    0% {
      transform: translate3d(-50%, -50%, 0) rotate(0deg);
    }
    100% {
      transform: translate3d(-50%, -50%, 0) rotate(360deg);
    }
  }
  .spinner {
    // The height here is just for demo purposes
    height: 100vh;
    opacity: 1;
    position: relative;
    transition: opacity linear 0.1s;
    &::before {
      animation: 2s linear infinite spinner;
      border: solid 3px #eee;
      border-bottom-color: #2f58b8;
      border-radius: 50%;
      content: "";
      height: 80px;
      left: 50%;
      opacity: inherit;
      position: absolute;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      transform-origin: center;
      width: 80px;
      will-change: transform;
    }
  }
</style>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
